import { render, staticRenderFns } from "./WebMedia.vue?vue&type=template&id=77d6924a&scoped=true"
import script from "./WebMedia.vue?vue&type=script&lang=js"
export * from "./WebMedia.vue?vue&type=script&lang=js"
import style0 from "./WebMedia.vue?vue&type=style&index=0&id=77d6924a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d6924a",
  null
  
)

export default component.exports